// extracted by mini-css-extract-plugin
export default {"container":"typ_2PsRz","inner":"typ_inn_3TajP","group":"typ_gro_Zflb4","items":"typ_ite_3Xp3X","item":"typ_ite_1teQ5"};